// extracted by mini-css-extract-plugin
module.exports = {"s1kq0v8n":"s1kq0v8n"};